import { css } from "@emotion/react";
import type { ShoppingCartItemModel } from "../../../hooks/useShoppingCartItemsState";
import { useStorefrontSettingsState } from "../../../hooks/useStorefrontSettingsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { AvailabilityCalendarPopupButton } from "../../ProductDetails/AvailabilityCalendarPopupButton";

export type ShoppingCartItemAvailabilityProps = {
	item: ShoppingCartItemModel;
};
export const ShoppingCartItemAvailability: React.FC<
	ShoppingCartItemAvailabilityProps
> = (props) => {
	const translate = useTranslate();
	const item = props.item;
	const product = item.product;

	const storefrontSettingsState = useStorefrontSettingsState();
	const showOwnedQty =
		storefrontSettingsState.get().settings?.ShowOwnedQty ?? false;
	const totalIn = product.Availability?.TotalIn ?? 0;
	const total = product.Availability?.Total ?? 0;
	let available = "";
	if (totalIn > 0) {
		available += totalIn;
		if (showOwnedQty) {
			available += ` ${translate("of")} ${total}`;
		}
		available += ` ${translate("available")}`;
	} else {
		available = translate("Unavailable");
	}

	return (
		<>
			{product.Availability && (
				<div
					className="field availability"
					css={css`
						/*display: flex;
						flex-direction: column;
						align-items: flex-start;
						justify-content: flex-start;*/
						gap: 0.5rem;
						padding: .25rem 0;
					`}
				>
					<AvailabilityCalendarPopupButton product={product}>
						<span>{available}</span>
					</AvailabilityCalendarPopupButton>
				</div>
			)}
		</>
	);
};
